import { Entry } from '../Entry'

export function Entry20230803() {
  return (
    <Entry title="Aug 03 2023 - v3.4.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13979/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
